import { z } from 'zod';

const BaseHistoryItem = z.object({
    id: z.string(),
    timestamp: z.string(),

    positionInCategory: z.number(),
    positionInSection: z.number(),
    metadataId: z.number(),
    categoryId: z.number(),
    sectionId: z.number(),
    sectionTeaserCount: z.number(),
    sectionTitle: z.string(),
    tenantId: z.number(),
});

const AddHistoryItem = z.object({
    ...BaseHistoryItem.shape,
    changeType: z.literal('ADD'),
    timestampEnd: z.string().nullable(),
});

const UpdateHistoryItem = z.object({
    ...BaseHistoryItem.shape,
    changeType: z.literal('UPDATE'),
    timestampEnd: z.string().nullable(),
});

const RemoveHistoryItem = z.object({
    ...BaseHistoryItem.shape,
    changeType: z.literal('REMOVE'),
    timestampEnd: z.string(),
});

export const HistoryItem = z.union([AddHistoryItem, UpdateHistoryItem, RemoveHistoryItem]);

export type HistoryItem = z.infer<typeof HistoryItem>;
